import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../App.css';

function PrivacyPolicy() {
  return (
    <div className="App">
      <Navbar />
      <header className="App-header" style={{alignItems: 'center'}}>
        <div className="form-container" style={{maxWidth: '800px', textAlign: 'left', alignItems: 'flex-start'}}>
          <h1>Privacy Policy</h1>
          <p><strong>Last Updated:</strong> November 24, 2025</p>

          <h3>1. Introduction</h3>
          <p>Luxer Graphics LLC d/b/a LuxerAssess ("we," "our," or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect data when you use our AI-powered assessment platform.</p>

          <h3>2. Information We Collect</h3>
          <ul>
            <li><strong>Client Data:</strong> Email address, encrypted password, and payment history.</li>
            <li><strong>Candidate Data:</strong> Email address, resume text, job descriptions, and assessment answers.</li>
            
            {/* REBRANDED FROM "SPY MODE" */}
            <li><strong>Proctoring & Telemetry Data ("Behavioral Integrity Monitoring"):</strong> To ensure assessment integrity, we collect behavioral data during the test session, including:
                <ul>
                    <li><strong>Focus Loss Events:</strong> timestamps of when the browser tab or window is hidden or loses focus.</li>
                    <li><strong>Paste Events:</strong> timestamps and frequency of text pasting into answer fields.</li>
                    <li><strong>Session Duration:</strong> total time spent on the assessment.</li>
                </ul>
            </li>
          </ul>

          <h3>3. How We Use Artificial Intelligence</h3>
          <p>We use third-party Large Language Models (LLMs) to generate questions and grade answers.</p>
          <ul>
            <li><strong>Data Processing:</strong> Resumes and Job Descriptions are sent to our AI provider to generate relevant questions.</li>
            <li><strong>Automated Scoring:</strong> Candidate answers are analyzed by AI to provide a preliminary score and feedback.</li>
            <li><strong>No Automated Decision Making:</strong> LuxerAssess provides <em>recommendations</em> only. The final hiring decision is always made by the human recruiter. We do not use AI to automatically reject candidates without human review.</li>
          </ul>

          <h3>4. Data Retention & Archiving</h3>
          <p><strong>Active Accounts:</strong> We retain Candidate Data (Results, Resume text, Integrity Logs) for the duration of your active account status to facilitate hiring history.</p>
          <p><strong>Client Data Retention Responsibility:</strong> The Client is solely responsible for exporting and archiving Assessment Reports (PDFs) to satisfy local employment record retention laws (e.g., California FEHA, EEOC). LuxerAssess acts as a data processor, not a permanent compliant archive.</p>
          <p><strong>Deletion:</strong> We generally delete data upon account termination or valid "Right to Erasure" requests, unless a "Legal Hold" is explicitly requested by the Client for active litigation.</p>
          <p><strong>International Transfers:</strong> LuxerAssess is based in the United States. If you are accessing our services from the European Economic Area (EEA), you acknowledge that your data will be processed in the United States. We adhere to standard data protection clauses to ensure your data remains protected according to GDPR standards.</p>

          <h3>5. Your Rights (GDPR & CCPA)</h3>
          <p>You have the right to request access to, correction of, or deletion of your personal data ("Right to be Forgotten"). You may also object to the processing of your data or request a portable copy. To exercise these rights, simply email support@luxerassess.com. We verify all requests to protect your security.</p>

          <h3>6. Contact Us</h3>
          <p>If you have questions about this policy, please contact us at support@luxerassess.com.</p>
        </div>
      </header>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;